import { get } from 'lodash';
import { Box, Stack, styled, TextField } from '@mui/material';
import { useFormikContext } from 'formik';
import update from 'immutability-helper';

// Components
import { IPropsDataContribute } from 'src/features/CompanyDetail/Common/config';
import TooltipFormLabel from 'src/components/common/TooltipFormLabel';
import UploadListImages from 'src/components/common/UploadListImages';
import { CancelOutlined } from '@mui/icons-material';

const StyledIconDelete = styled(CancelOutlined)(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(-1),
  right: theme.spacing(-1),
  backgroundColor: '#fff',
  cursor: 'pointer',
  borderRadius: 1000,
}));

const ClaimCompany = ({
  listImage,
  handleChooseImages,
}: {
  listImage: Array<TypeImage>;
  handleChooseImages: (images: Array<TypeImage>) => void;
}) => {
  const { values, handleChange, handleBlur, errors, touched } = useFormikContext<IPropsDataContribute>();

  const removeImage = (index: number) => {
    const newState = update(listImage, { $splice: [[index, 1]] });
    handleChooseImages(newState);
  };

  return (
    <Stack spacing={2} flex={1}>
      <TextField
        required
        id={`contribution_claim_your_company_profile.company_email`}
        name={`contribution_claim_your_company_profile.company_email`}
        value={get(values.contribution_claim_your_company_profile, 'company_email', '')}
        size="small"
        onChange={handleChange}
        onBlur={handleBlur}
        fullWidth
        error={Boolean(
          touched.contribution_claim_your_company_profile?.company_email &&
            errors.contribution_claim_your_company_profile?.company_email,
        )}
        helperText={
          Boolean(touched.contribution_claim_your_company_profile?.company_email) &&
          errors.contribution_claim_your_company_profile?.company_email
        }
        label={
          <span>
            Company Email <TooltipFormLabel title="Company Email" />
          </span>
        }
      />
      <UploadListImages listImage={listImage} handleChooseImages={handleChooseImages} />
      <Stack direction="row" spacing={4} useFlexGap flexWrap="wrap">
        {listImage.map((file, index) => (
          <Box key={file.name} position="relative">
            <StyledIconDelete fontSize="small" color="primary" onClick={() => removeImage(index)} />
            <img
              srcSet={file.url}
              src={file.url}
              width={64}
              height={64}
              alt={file.name}
              loading="lazy"
              style={{ objectFit: 'cover' }}
            />
          </Box>
        ))}
      </Stack>
    </Stack>
  );
};

export default ClaimCompany;
